export default __webpack_public_path__ + "locales/hy-AM/People.json?hash=af0ce9c43605273d61558fca3266b47e";